import {Analytics, GoogleAnalytics, FacebookPixel, LinkedInInsight, GoogleAnalyticsEventObserver} from '@plaudit/analytics';

declare type HubspotOnFormSubmitData = {
	type: "hsFormCallback",
	eventName: "onFormSubmitted",
	id: string,
	data: {name: string, value: string}[] // The contents of the form.
};

window.addEventListener("message", (event: MessageEvent ) => {
	if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormSubmit") {
		const data = event.data as HubspotOnFormSubmitData;

		const hubspotElements = document.getElementsByClassName("hs-form-" + data.id);
		let formNameForTracking: string = "";
		if (hubspotElements.length > 0) {
			const jQuery = (window as any).jQuery;
			const hubspotForm = jQuery(hubspotElements[0]).closest(".hubspotForm").get(0) as HTMLElement;
			formNameForTracking = hubspotForm.dataset.nameForTracking;
		}

		const analytics = Analytics.getInstance();
		analytics.trackEvent(
			"hubspotForm.onFormSubmitted",
			"Submitted: " + formNameForTracking,
			data.id
		);
	}
 });
